import React from 'react';

import { Container } from '../../../../symphony';
import { useQuery } from '../../../../shared/public/utilsPublic/utilsPublic';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { LessonCompleteCelebration } from '../LessonCompleteCelebration/LessonCompleteCelebration';
import { StreakCelebration } from '../StreakCelebration/StreakCelebration';
import { LeaderboardCelebration } from '../LeaderboardCelebration/LeaderboardCelebration';
import { StreakGoalScreen } from '../StreakGoalScreen/StreakGoalScreen';
import { SlDataService } from '../../services/sl-data.service';
import { SlLessonService } from '../../services/Business/sl-lesson.service';
import { SlLEContext } from '../../global-constants';
import { ScreenName } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { LessonCompletePaywall } from '../LessonCompletePaywall/LessonCompletePaywall';

const ScreenComponentMap: Record<ScreenName, () => JSX.Element> = {
	[ScreenName.LessonCelebration]: LessonCompleteCelebration,
	[ScreenName.Paywall]: LessonCompletePaywall,
	[ScreenName.StreakCelebration]: StreakCelebration,
	[ScreenName.StreakGoal]: StreakGoalScreen,
	[ScreenName.LeaderboardCelebration]: LeaderboardCelebration,
};

export function LessonCompleteContainer(): JSX.Element {
	const query = useQuery();

	const index = query.i?.length ? Number(query.i) : null;
	const next = Boolean(query.next);

	if (next) {
		const { nextLessonCompleteScreenIteration } = Container.take(SlLEContext, SlLessonService);
		nextLessonCompleteScreenIteration();
	}

	const { lessonCompleteScreens$: screens } = useContainerData(SlLEContext, SlDataService, [
		'lessonCompleteScreens$',
	]);

	const Screen = screens && index !== null && ScreenComponentMap[screens[index].name];

	return Screen && <Screen />;
}
